import moment from 'moment';
import { isNull } from 'lodash';
import arrayToTree from "array-to-tree";

export function parseScheduleBlockReportRequest(term, startDate, endDate, service, fileFormat) {
  return {
    ...(term && { termId: term.value }),
    ...(fileFormat === "xls" && { fileFormat: "xls" }),
    ...(fileFormat === "csv" && { generateCSV: "true" }),
    startDate: startDate.format("YYYY-MM-DD HH:mm"),
    endDate: endDate.format("YYYY-MM-DD HH:mm"),
    serviceId: service.value
  };
}

export const isFormValid = (startDate, endDate, service) => {
  if (!moment(startDate).isValid()) {
    return { validForm: false, errorMessage: "Start Date is invalid." };
  }
  if (!moment(endDate).isValid()) {
    return { validForm: false, errorMessage: "End Date is invalid or Date range exceeds 365 days." };
  }
  if (isNull(service)) {
    return { validForm: false, errorMessage: "Service is required." };
  }
  return { validForm: true, errorMessage: "" };
};

/**
 * Indent term options so it is easy to see term hierarchy:
 *     Academic Year 2019-2020
 *        Fall 2019
 *        Spring 2020
 *            Spring 2020A
 *            Spring 2020B
 *        Summer 2020
 *
 * @param {array} terms - list of terms
 * @returns {array}  terms in chronological and hierarchical order
 */
export const organizeHierarchicalTerms = terms => {
  let formattedTerms = [], depth = 0;
  const indentChars = "\xa0\xa0\xa0\xa0";
  const termTree = terms.length > 1 ? arrayToTree(terms, {
    parentProperty: 'parentTermId',
    customID: 'termId'
  }) : terms;

  /**
   * Sort out the indenting for one tree of terms
   * @param {array} tree - terms for one academic year in a tree structure
   */
  const indentTermTree = tree => {
    tree.forEach(function (node) {
        node.depth = depth;
        node.termName = depth > 0 ? indentChars + Array(depth).join(indentChars) + node.termName : node.termName;
        //the arrayToTree component sometimes adds array elements with the name remove - we don't want these as
       // as part of the tree structure.
        if (node.name !== 'remove') formattedTerms.push(node);
        if (node.children) {
          depth++;
          indentTermTree(node.children);
        }
        if (tree.indexOf(node) === tree.length - 1) {
          depth--;
        }
      }
    )
  }

  /**
   * The list of terms contains multiple chronological hierarchies of terms:
   *   e.g.   Academic Year 2019 - 2020 includes Fall 2019, Spring 2020, Summer 2020
   *          Summer 2020 (14 week term) includes Summer 2020A (7 week term) and Summer 2020B (7 week term)
   *   So Academic Year 2019 - 2020 is the parent and the root Term,
   *      Summer 2020 is both a parent term and a child term but it is not a root term
   * @param {array} rootTerms - list of terms
   * @returns {*} a list of terms with indented term names to show how they relate to each other
   *
   * e.g. Academic Year 2019-2020
   *        Fall 2019
   *        Spring 2020
   *        Summer 2020
   *            Summer 2020A
   *            Spring 2020B
   */
  const indentTerms = (rootTerms) => {
    for (let i = 0; i < rootTerms.length - 1; i++) {
      depth = 0;
      indentTermTree([rootTerms[i]]);
    }
    return formattedTerms.length > 0 ? formattedTerms : terms;
  }
  return indentTerms(termTree);
}
